function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { MultiSelectGroup, SingleSelectGroup } from "@xo-union/tk-component-switches";
import Icon from "@xo-union/tk-component-icons";
import { facetValueShape } from "../../utils/facet_prop_type.js";
import FilterItem from "../FilterItem/index.js";
import Styles from "./styles.css";
import { isMobile } from "../../utils/browser.js";
var FacetsGroup = function FacetsGroup(props) {
  var _useState = useState(props.is_default_filter),
    _useState2 = _slicedToArray(_useState, 2),
    showValues = _useState2[0],
    setShowValues = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    blockLeftCss = _useState4[0],
    setBlockLeftCss = _useState4[1];
  var _useState5 = useState(new _Set([])),
    _useState6 = _slicedToArray(_useState5, 2),
    multiSelected = _useState6[0],
    setMultiSelected = _useState6[1];
  useEffect(function () {
    props.is_default_filter && isMobile() ? setShowValues(props.selected !== undefined || false) : setShowValues(props.selected !== undefined || props.is_default_filter);
  }, [props.is_default_filter]);
  var handleMultiChange = function handleMultiChange(newValues) {
    setMultiSelected(newValues);
  };
  var handleChange = function handleChange(e) {
    var value = e.currentTarget.value;
    var data = {
      seo_slug: props.seo_slug,
      value: value,
      is_radio_button: props.select_type === 'radio'
    };
    props.onChange(data);
  };
  var handleCollapse = function handleCollapse(e) {
    var offsetTop = e.currentTarget.offsetTop;
    if (isMobile() && !showValues) {
      _setTimeout(function () {
        var startTime = performance.now();
        var distance = offsetTop - window.scrollY;
        var duration = 500;
        function navigate(currentTime) {
          var elapsedTime = currentTime - startTime;
          var progress = Math.min(elapsedTime / duration, 1);
          window.scrollTo({
            top: Math.min(window.scrollY + distance * (progress / 4), offsetTop),
            left: 0,
            behavior: 'auto'
          });
          if (elapsedTime < duration) {
            requestAnimationFrame(function () {
              return navigate(performance.now());
            });
          }
        }
        requestAnimationFrame(function () {
          return navigate(performance.now());
        });
      }, 500);
    }
    setShowValues(!showValues);
  };
  var isSwatch = function isSwatch() {
    return /color$/.test(props.seo_slug);
  };
  var isGrid = function isGrid() {
    return props.seo_slug === 'silhouette';
  };
  var noneInfo = function noneInfo() {
    return {
      seo_slug: 'none',
      label: isGrid() ? 'All' : 'Any'
    };
  };
  var selectedValue = function selectedValue() {
    return props.selected || noneInfo().seo_slug;
  };
  var filterValues = function filterValues() {
    var values = _toConsumableArray(_valuesInstanceProperty(props));
    if (!isSwatch()) {
      values.unshift(noneInfo());
    }
    return values;
  };
  var showFilterOptions = function showFilterOptions() {
    var _context;
    return _mapInstanceProperty(_context = filterValues()).call(_context, function (facet_value) {
      return /*#__PURE__*/React.createElement(FilterItem, _extends({}, facet_value, {
        key: facet_value.seo_slug,
        is_wedding_dresses: props.is_wedding_dresses,
        value: facet_value.seo_slug,
        showValues: showValues,
        isGrid: isGrid(),
        isSwatch: isSwatch(),
        onChange: handleChange,
        selected: selectedValue(),
        isRadioButton: isRadioButton()
      }));
    });
  };
  var filterValuesContainerClass = function filterValuesContainerClass() {
    var classes = Styles.slide;
    classes += " ".concat(isSwatch() ? Styles['color-filter-values-container'] : '');
    classes += " ".concat(showValues ? Styles.slidedown : Styles.slideup);
    classes += " ".concat(isGrid() && props.is_wedding_dresses ? Styles['silhouette-carousel'] : '');
    return classes;
  };
  var filterValuesClass = function filterValuesClass() {
    var classes = '';
    classes += " ".concat(isSwatch() ? Styles['color-filter-values'] : 'other-facet-values');
    if (isGrid()) {
      classes += " ".concat(Styles['grid-filter-values']);
    }
    return classes;
  };
  var handleScroll = function handleScroll(e) {
    var scrollLeft = e.target.scrollLeft;
    var viewportWidth = window.innerWidth;
    var blockLeft = scrollLeft * (168 - 75) / (745 - viewportWidth);
    setBlockLeftCss("".concat(blockLeft, "px"));
  };
  var space2Hyphen = function space2Hyphen(str) {
    return str.replace(/ /g, '-');
  };
  var isRadioButton = function isRadioButton() {
    return props.select_type === 'radio';
  };
  var selected = selectedValue();
  var isRadioButtonType = isRadioButton();
  return /*#__PURE__*/React.createElement("div", {
    "aria-labelledby": "facet-label-".concat(space2Hyphen(props.facet_label)),
    className: "".concat(Styles['facet-section'], " ").concat(showValues ? Styles.open : ''),
    onScroll: handleScroll,
    role: isRadioButtonType ? 'radiogroup' : 'checkbox'
  }, /*#__PURE__*/React.createElement("div", {
    "aria-controls": "facet-".concat(space2Hyphen(props.facet_label)),
    "aria-expanded": showValues,
    className: "".concat(Styles['facet-header'], " ").concat(showValues ? Styles.open : ''),
    id: "facet-label-".concat(space2Hyphen(props.facet_label)),
    onClick: handleCollapse,
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("span", {
    className: Styles['facet-label']
  }, props.facet_label), /*#__PURE__*/React.createElement(Icon, {
    name: showValues ? 'caret_up' : 'caret_down',
    className: "union-icon",
    size: "sm",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement("div", {
    className: filterValuesContainerClass(),
    id: "facet-".concat(space2Hyphen(props.facet_label)),
    "aria-hidden": !showValues
  }, /*#__PURE__*/React.createElement("div", {
    className: filterValuesClass()
  }, isRadioButtonType ? /*#__PURE__*/React.createElement(SingleSelectGroup, {
    value: selected,
    onChange: handleChange
  }, showFilterOptions()) : /*#__PURE__*/React.createElement(MultiSelectGroup, {
    values: multiSelected,
    onValuesChange: handleMultiChange
  }, showFilterOptions())), isGrid() && props.is_wedding_dresses ? /*#__PURE__*/React.createElement("div", {
    className: Styles['custom-scrollbar']
  }, /*#__PURE__*/React.createElement("div", {
    className: Styles['scroll-block'],
    style: {
      left: blockLeftCss
    }
  })) : ''));
};
process.env.NODE_ENV !== "production" ? FacetsGroup.propTypes = {
  is_wedding_dresses: PropTypes.bool,
  seo_slug: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(facetValueShape()).isRequired,
  is_default_filter: PropTypes.bool,
  selected: PropTypes.string,
  select_type: PropTypes.string,
  onChange: PropTypes.func.isRequired
} : void 0;
export default FacetsGroup;